<template>
    <v-card elevation="0">
        <v-card-actions>
            <v-btn :disabled="!amount" icon @click.stop="decrease(item)">
                <v-icon>mdi-minus</v-icon>
            </v-btn>

            <v-text-field
                type="number" 
                outlined 
                dense
                v-model="amount" 
                hide-details
                :step="vpe"
                :min="vpe"
                @keyup.enter="changeQuantity()" 
                @change="changeQuantity()"
            />

            <v-btn :disabled="!amount" icon @click.stop="increase(item)">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-card-actions>

        <v-snackbar
            v-model="snackbar"
            top
            right
            color="primary"
            transition="slide-x-reverse-transition"
        >
            Menge wurde auf die nächste VPE aufgerundet!
        </v-snackbar>
    </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";

export default {
    props: ["item"],

    data: () => ({
        snackbar: false
    }),

    computed: {
        ...mapGetters("cart", ["cart"]),

        vpe() {
            if (!this.item.extdata.e_VPE) return 1;
            
            return this.item.extdata.e_VPE
                ? parseInt(this.item.extdata.e_VPE.replace('*', '')) 
                : 1;
        },

        obligatedVpe() {
            return this.item.extdata.e_VPE && this.item.extdata.e_VPE.match(/[*]/) ? true : false
        },

        amount: {
            get: function() {
                let cartLineItem = _.find(this.cart, ["item", this.item.item]);

                return cartLineItem.amount;
            },

            set: function(value) {
                let cartLineItem = _.find(this.cart, ["item", this.item.item]);

                cartLineItem.amount = value;
            }
        },
    },

    methods: {
        ...mapActions("cart", ["changeCartItemQuantity"]),

        changeQuantity() {
            if (!parseInt(this.amount)) {
                this.amount = this.vpe;
                return false;
            }

            if (parseInt(this.amount) < 0) {
                this.amount = this.vpe;
                return
            }

            if (this.obligatedVpe) {
                this.snackbar = false;

                let quantity = parseInt(this.amount)/this.vpe;
                this.amount = Math.ceil(quantity) * this.vpe;

                this.snackbar = true;
            }

            this.changeCartItemQuantity({
                item: this.item,
                quantity: parseInt(this.amount)
            })
        },

        increase() {
            this.changeCartItemQuantity({
                item: this.item,
                quantity: parseInt(this.amount) + parseInt(this.vpe)
            })
        },

        decrease() {
            if (this.amount <= this.vpe) {
                return;
            }
            
            this.changeCartItemQuantity({
                item: this.item,
                quantity: parseInt(this.amount) - parseInt(this.vpe)
            })
        },
    }
}
</script>

<style>

</style>